import React, { useEffect, useState } from "react";
import QuestionTabs from "./QuestionTabs";
import PaginationNew from "../common/Pagination";
import api from "../../seller-apis/api";
import { fetchunansQA, fetchIgnoredQA } from "../../seller-apis/apidataField";
import SubmitAnswerModal from "../common/SubmitAnswerModal";
import { Actions } from "../../Actions/Actions";
import { useDispatch } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import MainLoader from "../common/Loader/PageLoader";
var filterData = {};

function IgnoredQuestions(props) {
  const dispatch = useDispatch();
  const [answQ, setanswQ] = useState([]);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    filterData = {
      pageNo: "1",
      type: "IGNORED",
    };
    getQA(filterData);
  }, []);
  function getQA(data = filterData, updateAction = null) {
    setLoading(true);
    api.QandA.fetchQA(fetchunansQA(data)).then((res) => {
      updateAction=='action' && Actions.upadteQuesCount(dispatch, res.totalRecords);
      setanswQ([...res.data]);
      setTotalRecords(res.totalRecords);
      setLoading(false);
    });
  }
  function paginate(data) {
    filterData = {
      pageNo: data.number,
      type: "IGNORED",
    };
    getQA(filterData);
    setSelectedPage(data.number);
  }
  const refreshData = () => {
    getQA(filterData, "action");
  };

  if (loading) {
    return (
      <div className="question_loading_box">
        <div>
          <MainLoader />
        </div>
      </div>
    )
  }
  else {
    return (
      <>
        <div className="question-container table-responsive">
          <table className="w-100 new-table-design pt-2">
            <tr>
              <th style={{ width: "15%" }}>Image</th>
              <th style={{ width: "25%" }}>Product</th>
              <th style={{ width: "30%" }}>Question</th>
              <th style={{ width: "14%" }}>Action</th>
            </tr>
            {answQ.length > 0 &&
              answQ.map((item, index) => {
                // let baseImg = "";
                // item.productId.images.map((item) => {
                //   if (item.baseImage === true) {
                //     if (item.image.startsWith("products")) {
                //       baseImg = item.image;
                //     } else {
                //       let img = item.image.substr("41");
                //       baseImg = img;
                //     }
                //   }
                // });
                let answer = item.answers[item.answers.length - 1];
                return (
                  <tr>
                    <td>
                      <div className="border-x">
                        <img
                          src={
                            "https://s3.toolsvilla.com/" +
                            item.productId.images[0].image
                          }
                          className="col3"
                        ></img>
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x px-2">
                        <div className="product-name text-left w-100 mt-1">
                          {item.productId.productName}
                        </div>
                        <div className="question-sku-but">
                          <div className="sku w-100">
                            SKU : {item.productId.SKU}
                          </div>
                          <a
                            href={`/productDetail/${item.productId._id}/approv`}
                            target="_blank"
                            // onClick={() => detailnew(props.url)}
                            className="detail-but"
                          >
                            <button className="px-1 order_table_btn_details">
                              Details
                            </button>
                          </a>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className=" text-left border-x question">
                        {item.question}
                      </div>
                    </td>
                    <td>
                      <div className="border-x">
                        <button
                          className="download_manifest_btn_orders icon-but mb-1"
                          onClick={() => {
                            setSelectedData(item);
                            setShow(true);
                          }}
                        >
                          {" "}
                          <img src="/edit-line.webp" /> Answer This Question
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </table>
          <PaginationNew
            number={totalrecords}
            paginate={paginate}
            activ={selectedPage}
            comp={"ignored"}
          />
          {show ? (
            <SubmitAnswerModal
              data={selectedData}
              show={show}
              handleClose={handleClose}
              refreshData={refreshData}
            />
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}

export default IgnoredQuestions;
